import {DictionaryItem, DictionaryItemSimplified} from './dictionary.model';

export class SimplifiedOceanPolicy {
    auctionId: string;
    auctionName: string;
    consents: Consent[];
    downloadableDocuments: OceanPolicyDownloadableDocuments;
    grossPremium: number;
    history: HistoryRecord[];
    installments: Installment[];
    insuranceStart: string;
    insuranceEnd: string;
    insured: Insured;
    insuredSubject: OceanPolicyInsuredSubject;
    paymentType: DictionaryItem;
    policyNumber: string;
    premiumToReturn: number;
    risks: OceanPolicyRisk[];
    signatureOwu: string;
    status: DictionaryItemSimplified;

    variant: DictionaryItemSimplified;
    versionDate: string;

    constructor(props = {}) {
        Object.assign(this, props);
    }

    isNaturalPerson() {
        return this.insured?.personType.code === 'NATURAL_PERSON';
    }

    isLegalEntityPerson() {
        return this.insured?.personType.code === 'LEGAL_ENTITY';
    }
}

export class OceanPolicyChanges {
    insured: Insured;
    consents: Consent[];

    constructor(props = {}) {
        Object.assign(this, props);
    }
}

export class OceanPolicyInsuredSubject {
    group: DictionaryItem;
    subgroup: DictionaryItem;
    brand: string;
    model: string;
    serialNumber: string;
    warrantyPeriod: number;
}

export class Insured {
    personType: DictionaryItem;
    firstName: string;
    lastName: string;
    companyName: string;
    taxId: string;
    regon: string;
    phone: string;
    email: string;
    streetNumber: string;
    street: string;
    postalCode: string;
    city: string;
    idCard: string;
    passport: string;
    pesel: string;

    constructor(props = {}) {
        Object.assign(this, props);
    }
}

export class OceanPolicyRisk {
    code: string;
    description: string;
    insuranceStart: string;
    insuranceEnd: string;
    sumOfInsurance: number;
}

export class Installment {
    no: number;
    dueTo: string;
    value: number;
}

export class Consent {
    code: string;
    description: string;
    checked: boolean;
}

export class HistoryRecord {
    version: number;
    eventSource: DictionaryItem;
    eventDate: string;
    eventType: DictionaryItem;
}

export class OceanPolicyRegistryItem {
    email: string;
    insuranceFrom: string;
    insuranceTo: string;
    issueDate: string;
    partnerName: string;
    policyNumber: string;
    premium: number;
    productCode: string;
    statusCode: string;
    variantCode: string;

    constructor(props = {}) {
        Object.assign(this, props);
    }
}

export class TerminationReason {
    code: string;
    description: string;
    dictionaryCode: string;
    translation: {en: string, pl: string};
}

export class OceanPolicyFile {
    description: string;
    email: string;
    fileHash: string;
}

export class OceanPolicyDocument {
    fileName: string;
    fileHash: string;
    fileSize: string;
    email: string;
    description: string;
    creationTimestamp: string;
}

export class OceanPolicyDownloadableDocuments {
    kidHash: string;
    owuHash: string;
}
